const datesConfig = {
  defaultFormat: 'extended', // Default date format when unspecified
  formats: { // https://date-fns.org/v2.25.0/docs/format
    // Customizable display formats
    short:         'yyyy-MM-dd',               // 2021-12-31
    long:          'PP',                       // Dec 12, 2021
    extended:      'PPPP',                     // Sunday, December 12th, 2021
    dateTime:      "yyyy-MM-dd h:mmaaa 'UTC'", // 2021-12-31 12:34am UTC
    url:           'yyyyMMdd',                 // 20211231

    tickYear:      'yyyy',               // 2021
    tickYearMonth: 'yyyy-MM',            // 2021-12
    tickDate:      'yyyy-MM-dd',         // 2021-12-31
    tickDateTime:  'yyyy-MM-dd h:mmaaa', // 2021-12-31 12:34am

    picker:        'yyyy-MM-dd',         // Date-picker format
    fromPicker:    'Y-m-d',              // (https://flatpickr.js.org/formatting)
    data:          'yyyy-MM-dd',         // 2021-12-31 (For JSON-LD data)
  },
};

export default datesConfig;
